import { Case, ServiceType } from '@/payload-types';

export function filterCasesBySelections(
    cases: Case[],
    selectedServices: ServiceType[],
    selectedQuestions: string[],
): Case[] {
    if (selectedServices.length === 0 && selectedQuestions.length === 0) {
        return cases;
    }

    return [...cases]
        .map((caseItem) => {
            let score = 0;

            // Count matches for selected services
            const caseServices = caseItem.algemeneInformatie.diensten.map(
                (d) => (typeof d.dienst === 'string' ? d.dienst : d.dienst.id),
            );
            const selectedServiceIds = selectedServices.map((s) => s.id);
            const serviceMatches = caseServices.filter((id) =>
                selectedServiceIds.includes(id),
            );
            score += serviceMatches.length;

            // Count matches for selected questions
            const question = caseItem.algemeneInformatie.vraagstuk;
            const caseQuestionId =
                typeof question === 'object' && question !== null
                    ? question
                    : typeof question === 'string'
                      ? question
                      : undefined;
            const selectedQuestionIds = selectedQuestions;
            if (
                caseQuestionId &&
                selectedQuestionIds.includes(caseQuestionId)
            ) {
                score += 1;
            }

            return { caseItem, score };
        })
        .filter((entry) => entry.score > 0)
        .sort((a, b) => b.score - a.score)
        .map((entry) => entry.caseItem);
}
